<mat-toolbar color="primary" class="app-toolbar">
  <!-- Logo / Accueil -->
  <!-- <button mat-icon-button routerLink="/" aria-label="Accueil">
    <mat-icon fontSet="material-symbols-outlined">flight</mat-icon>
  </button> -->

  <!-- Menu déclenché via le composant -->
  <app-main-menu [items]="mainMenu"></app-main-menu>

  <span class="app-title">Aéroclub de Genève</span>

  <span class="sp"></span>

  <!-- Rafraîchir la page courante -->
  <button mat-icon-button (click)="refresh()" aria-label="Rafraîchir">
    <mat-icon fontSet="material-symbols-outlined">refresh</mat-icon>
  </button>

  <!-- Profil / menu utilisateur -->
  <button
    mat-icon-button
    [matMenuTriggerFor]="userMenu"
    aria-label="Menu utilisateur"
  >
    <span class="material-symbols-outlined"> account_circle </span>
  </button>
</mat-toolbar>

<!-- === MENU UTILISATEUR EXISTANT === -->
<mat-menu #userMenu="matMenu">
  <span class="user-name">
    {{ authService.currentUser?.firstname }}
    {{ authService.currentUser?.lastname }}
  </span>
  <button mat-menu-item routerLink="/profile">
    <mat-icon fontSet="material-symbols-outlined">person</mat-icon>
    <span>My profile</span>
  </button>
  <button mat-menu-item routerLink="/favorites">
    <mat-icon fontSet="material-symbols-outlined">tune</mat-icon>
    <span>Settings</span>
  </button>
  <mat-divider></mat-divider>
  <button mat-menu-item (click)="logout()">
    <mat-icon fontSet="material-symbols-outlined">logout</mat-icon>
    <span>Logout</span>
  </button>
</mat-menu>
